import { t } from 'i18next'

import ThumbVideoZoomable from '~/components/ThumbVideoZoomable'

import ItemVideo from './elements/ItemVideo'

// schema baseado no ItemVideo com colunas para midia e demais informações
export const schemaBannerVideo: SchemaMediaReviewItems = {
  /**
   * Dados do anúncio
   */
  asset: {
    title: t('rm:adReview.list.title'),
    render: data => <ThumbVideoZoomable url={data.settings.media_url} />,
    showTotal: true
  },
  title: {
    // Row.tsx calls `render(infoRow)` as a plain function call, not JSX —
    // wrapping ItemVideo in an element here gives it its own fiber, so its
    // internal useState isn't attributed to Row's memoized fiber (which
    // would otherwise make Row's hook count vary with the row count).
    render: data => <ItemVideo key={data.id} {...data} />,
    width: '100%'
  }
}
